<template>
  <confirm-modal ref="modal">
    <template slot="body">
      <p>Deseja realmente mudar para um plano inferior ao atual? A mudança irá se concretizar apenas para seu próximo ciclo ({{ changeDate }}). </p>
    </template>
  </confirm-modal>
</template>

<script>
import ConfirmModal from '@/support/components/modal/ConfirmModal.vue';
import { mapState } from 'vuex';
import dayjs from 'dayjs';

export default {
  name: 'ConfirmChangePlan',

  methods: {
    /**
     * Confirm the change endpoint name.
     *
     * @returns {Promise<boolean>}
     */
    confirm() {
      return this.$refs.modal.confirm();
    },
  },

  computed: {
    changeDate() {
      return dayjs(this.user.organizationPlan.due_date).add(1, 'month').format('DD/MM/YYYY');
    },
    ...mapState('auth', {
      user: 'user',
    }),
  },

  components: {
    ConfirmModal,
  },
};
</script>

<style lang="scss" scoped>

</style>
